import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Angular 21 bootstraps zoneless by default, but this app is written against zone.js
    // semantics: components mutate plain properties from HTTP/timer callbacks (e.g.
    // complete-page's `done` flag set in the submit_done response) with no signal or
    // markForCheck, so zoneless leaves those views stale — the 3D Secure return screen would
    // stay stuck on "Card authentication in progress" until an unrelated event triggered a tick.
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      })
    )
  ]
};
